import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import { EventCard } from '../../components';
import { host } from '../../settings/environment';
import { Link } from 'react-router-dom';

const styles = StyleSheet.create({
  container: {
    paddingVertical: 100,
  },
  title: {
    fontSize: 40,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 20,
  },
  eventList: {
    flexWrap: 'wrap',
    justifyContent: 'center',
    flexDirection: 'row',
    width: '100%',
  },
});

function UpcomingEvents() {
  const [events, setEvents] = React.useState([]);
  const fetchUpcomingEvents = () =>
    fetch(`${host}/api/public/events/upcoming/`)
      .then(response => response.json())
      .then(upcomingEvents => setEvents(upcomingEvents))
      .catch(e => console.log(e));
  React.useEffect(() => {
    fetchUpcomingEvents();
  }, []);
  if (events.length === 0) {
    return null;
  }
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Die nächsten Treffen</Text>
      <View style={styles.eventList}>
        {events.map(event => (
          <Link key={event.id} to={`/events/${event.id}`}>
            <View style={{ maxWidth: 400, width: '100%' }}>
              <EventCard event={event} isPublicSite />
            </View>
          </Link>
        ))}
      </View>
    </View>
  );
}

export default UpcomingEvents;
